import { resources } from "@constants/hardcoded-strings";
import { CommonReferenceDataPageTypes } from "@enums/common-reference-data-page-types";
import { ReferenceDataSourceTypes } from "@enums/reference-data-source-types";
import { ReferenceDataTypes } from "@enums/reference-data-types";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { CommonReferenceData, CommonReferenceDataState } from "@idw-types/state/common-reference-data-state";
import { setPartialCommonReferenceData, setPartialCommonReferenceDataLoading } from "@redux/actions/common-reference-data-actions";
import { getReferenceDataRequest } from "@requests/reference-data/get-reference-data-request";
import { GetAxnRpServicesRequestResponse, getAxnRpServicesRequest } from "@requests/service-configuration";
import { handleResponse } from "@utils/promise-util";
import { Dispatch } from "redux";

export const getCommonReferenceDataReduxRequest = (dispatch: Dispatch, ignoreLoading = false) => async (
    referenceDataTypes: Array<ReferenceDataTypes>,
    dataSource: ReferenceDataSourceTypes,
    commonReferenceDataPageType: CommonReferenceDataPageTypes,
    shouldGetAxnRpServices?: boolean,
    endpointType?: string,
    relyingPartyId?: string
): Promise<Partial<CommonReferenceDataState>> => {
    if(!ignoreLoading){
        dispatch(setPartialCommonReferenceDataLoading(true, commonReferenceDataPageType));
    }
  
    const requests: Array<Promise<GenericNetworkResponse<
        Partial<CommonReferenceData> |
        GetAxnRpServicesRequestResponse
    >>> = [getReferenceDataRequest(referenceDataTypes, dataSource)];

    if (shouldGetAxnRpServices) {
        requests.push(getAxnRpServicesRequest(endpointType, relyingPartyId));
    }

    const responses = await Promise.allSettled(
        requests
    );

    let commonReferenceData: Partial<CommonReferenceData> = {};
    responses.forEach((response, index) => {
        if (index === 0) {
            const responseWithType = response as PromiseSettledResult<GenericNetworkResponse<Partial<CommonReferenceData>>>;
            const data = handleResponse<Partial<CommonReferenceData>>(
                dispatch,
                responseWithType,
                resources.requests.referenceData.error.title,
                resources.requests.referenceData.error.message,
            );
            commonReferenceData = data;
        } else if (index === 1) {
            const responseWithType = response as PromiseSettledResult<GenericNetworkResponse<GetAxnRpServicesRequestResponse>>;
            const data = handleResponse<GetAxnRpServicesRequestResponse>(
                dispatch,
                responseWithType,
                resources.requests.referenceData.error.title,
                resources.requests.referenceData.error.message,
            );
            if (data?.axnRPServices && commonReferenceData) {
                commonReferenceData = {
                    ...commonReferenceData,
                    axnRPServices: data.axnRPServices
                }
            }
        }
    });

    dispatch(setPartialCommonReferenceData(commonReferenceData, commonReferenceDataPageType));

    return null;

};